// IndexedDB wrapper class
export class IndexedDB {
  // connect to IndexedDB database
  constructor(dbName, dbVersion, dbUpgrade) {
    return new Promise((resolve, reject) => {
      // connection object
      this.db = null

      // no support
      if (!('indexedDB' in window)) {
        reject('not supported')
      }

      // open database
      const dbOpen = indexedDB.open(dbName, dbVersion)

      if (dbUpgrade) {
        // database upgrade event
        dbOpen.onupgradeneeded = (e) => {
          dbUpgrade(dbOpen.result, e.oldVersion, e.newVersion)
        }
      }

      dbOpen.onsuccess = () => {
        this.db = dbOpen.result
        resolve(this)
      }

      dbOpen.onerror = (e) => {
        reject(`IndexedDB error: ${e.target.errorCode}`)
      }
    })
  }

  // return database connection
  get connection() {
    return this.db
  }

  saveEvent(storeName, data) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(storeName, 'readwrite')
      const store = transaction.objectStore(storeName)
      store.add(data)

      transaction.oncomplete = () => {
        resolve(true)
      }

      transaction.onerror = () => {
        reject(transaction.error)
      }
    })
  }

  getEvents(storeName) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(storeName, 'readonly')
      const store = transaction.objectStore(storeName)
      const request = store.getAll()

      transaction.oncomplete = () => {
        resolve(request.result)
      }

      transaction.onerror = () => {
        reject(request.error)
      }
    })
  }

  removeEvents(storeName) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(storeName, 'readwrite')
      const store = transaction.objectStore(storeName)
      const request = store.clear()

      transaction.onsuccess = () => {
        resolve('success')
      }

      transaction.onerror = () => {
        reject(request.error)
      }
    })
  }
}
